import React, { FC, useState } from 'react';
import Textbox from '~/src/components/form-components/textbox/textbox';
import { antispamAutoCompleteKey } from '~/src/components/common-components/domain-url-field/domain-url-field.constants';
import { TextBoxFieldProps } from '~/src/models/types/fields.types';
import * as Styled from '~/src/components/common-components/domain-url-field/domain-url-field.styles';

export const DomainUrlField: FC<TextBoxFieldProps> = (props) => {
    const [value, setValue] = useState('');

    return (
        <Styled.DomainUrlFieldWrap>
            <Textbox
                onValueChange={(e) => setValue(e.target.value)}
                value={value}
                onClear={() => setValue('')}
                autoComplete={antispamAutoCompleteKey}
                {...props}
            />
        </Styled.DomainUrlFieldWrap>
    );
};
